import React from 'react';

import { useContestCreateData } from '~/domains/contest/domains/managev2/hooks/useContestManageData';
import { ContestManagePage } from '~/domains/contest/domains/managev2/domains/common/components/ContestManagePage/ContestManagePage';
import withCreateContestRedirect from '~/domains/contest/domains/managev2/domains/common/resolvers/createContestRedirect.resolver';
import LegacyContestCreatePage from '~/domains/contest/domains/manage/domains/create/ContestCreatePage';

interface NextPageWithLayout extends React.FC {
  hasOwnAppshell?: boolean;
  isPublic?: boolean;
  trackingName?: string;
}

function ContestCreate() {
  const { data, isLoading, error } = useContestCreateData();

  return (
    <ContestManagePage
      data={data}
      isLoading={isLoading}
      error={error}
      operation="create"
      legacyComponent={LegacyContestCreatePage}
      loadingTitle="Create contest"
    />
  );
}

const ContestCreateWithRedirect = withCreateContestRedirect(ContestCreate) as NextPageWithLayout;

ContestCreateWithRedirect.hasOwnAppshell = true;
ContestCreateWithRedirect.isPublic = true;
ContestCreateWithRedirect.trackingName = 'Create a Contest';

export default ContestCreateWithRedirect;
